import { useTranslation } from 'react-i18next';
import { Skill } from '../types';
import { localized } from '../utils';

interface SkillBadgeProps { skill: Skill; showCategory?: boolean; }

export default function SkillBadge({ skill, showCategory = false }: SkillBadgeProps) {
  const { i18n } = useTranslation();
  const lang = i18n.language;
  return (
    <span className="inline-flex items-center text-sm px-3.5 py-1.5 rounded-full border border-zinc-700 text-zinc-200">
      {showCategory && <span className="opacity-60 mr-1">{localized(skill.category, lang)}:</span>}
      {localized(skill.name, lang)}
    </span>
  );
}
